import { PersonalizationClient } from "@bloomberg/intercom";

const personalizationClient = PersonalizationClient.init({
    host: process.env.NEXT_PUBLIC_PERSONALIZATION_URL,
});

export { personalizationClient };
